import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import LightString from './LightString';
import LocalizationUIAssets from '../Localization-UIAssets';

export default class GameTitleText extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y
   */
  constructor(scene, x, y, scale = 1, numberOfLights = 22, includeSubtitle = gameData.isMathVersion) {
    super(scene, x, y);

    this.scene.add.existing(this);

    this.title = ABCyaPhaser.Images.addImage(0, 0, includeSubtitle ? LocalizationUIAssets._title_christmas_lights_math : LocalizationUIAssets._title_christmas_lights, this, ABCyaPhaser.Images.LOCALIZATION_ATLAS)
    .setOrigin(0.5)
    .setScale(scale);

    // generate the position of the lights around the title using the bounds of the text
    // we don't want to include the subtitle, so get the bounds before we add it
    const titleLightPositions = this.getBounds().getPoints(numberOfLights).reverse();
    Phaser.Utils.Array.RotateRight(titleLightPositions);


    // TODO may need some additional work to make the lights sit on the text a bit better
    titleLightPositions.forEach(pos =>{
      // randomly adjust the positions so they aren't exactly on the rectangle box
      pos.x += Phaser.Math.FloatBetween(-5, 5);
      pos.y += Phaser.Math.FloatBetween(-5, 5);
    });

    this.lights = new LightString(this.scene, titleLightPositions);
  }

  destroyLightString() {
    this.lights.destroy();
  }
}